<template>
  <div>
      <home-header> </home-header>
      <code-creator> </code-creator>
  </div>
</template>

<script>

import HomeHeader from './components/Header';
import CodeCreator from './components/Creator';

export default {
  name: 'Home',
  components: {
    HomeHeader,
    CodeCreator,
  },
  data() {
    return {
      msg: 'My QRCode Creator',
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue